import {Link} from 'react-router-dom'
import {motion} from 'framer-motion'
import {baseurl} from "../../services/services";
import {ArrowCircleLeft} from "@mui/icons-material";


const Blogcard = ({image, id, time, title, text}) => {


    return (
        <>

            <motion.div className='column  p-3 is-12-mobile is-6-tablet  is-3-desktop '  variants={{
                hidden: {scale: 0},
                visible: {scale: 1, opacity: 1}
            }}>

                <Link to={`/news/${id}`}>


                    <div className='productcard  borderrad1' >
                        <div
                            className='mx-auto is-flex is-flex-direction-row is-flex-wrap-wrap   is-align-content-start is-justify-content-start   backgroundadj  '

                        >

                            <img src={`${baseurl}/${image}`} alt="" style={{height: '18rem' , width: '100%'}} />

                            <span
                                className='clrone has-text-white borderrad1 clrtwotext   kook is-size-6 ml-5 p-1 my-auto'
                               >
                                 {time}
                              </span>


                        </div>


                        <p className='kook is-size-4 mb-1 has-text-white has-text-centered '>
                            {
                                title
                            }


                        </p>

                        <div className='has-text-left'>

                            <button

                                className='button  clrone clrtwotext   clrone kook has-text-white noborder    has-text-weight-bold '
                            >


                                متن کامل خبر
                                <ArrowCircleLeft className='mr-3' />
                            </button>
                        </div>





                    </div>
                </Link>


            </motion.div>


        </>
    )
}

export default Blogcard;